<template>
    <div class="m-listingitem">
        <div class="e-image" v-if="resultItem.IsVirtual && !hideImage">
            <a :href="returnVirtualUrl(resultItem.Url)" v-if="resultItem.Url">
                <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
            </a>
        </div>
        <div class="e-image" v-else-if="!hideImage">
            <a :href="returnUrl(resultItem.Link)" v-if="resultItem.Link">
                <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
            </a>
        </div>
        <div class="e-text full">
            <div class="top">
                <p class="contentcategory">News article</p>

                <h3 v-if="resultItem.IsVirtual"><a :href="returnVirtualUrl(resultItem.Url)">{{resultItem.Heading}}</a></h3>
                
                <h3 v-else><a :href="returnUrl(resultItem.Link)">{{resultItem.Heading}}</a></h3>

                <p><strong>{{formatDate(resultItem.Date.DateTime)}}</strong></p>

                <p :title="resultItem.Summary">{{truncate(resultItem.Summary)}}</p>
            </div>

            <div class="buttons myhie">
                <a :href="returnVirtualUrl(resultItem.Url)"
                   class="btn"
                   v-if="resultItem.IsVirtual && resultItem.Url">Find out more</a>

                <a :href="returnUrl(resultItem.Link)"
                   class="btn"
                   v-if="!resultItem.IsVirtual && resultItem.Link">Find out more</a>
                <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
            </div>
        </div>
    </div>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { format, toDate } from '@/utils/date.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },

            isMainSite: function () {
                return window.location.host == 'hie.local' || window.location.host == 'hie.co.uk'
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
        }
    }
</script>